/* eslint-disable */
import { StyleSheet ,Dimensions} from 'react-native'

const { width } = Dimensions.get("window")
const screenWidth = width
const itemWidth = (width) / 4
const itemHeight = itemWidth
export default StyleSheet.create({
  container: {

  },
  flex :{
    flex : 1
  },
  image : {
   
    borderColor: '#FFFFFF',
    borderWidth : 0,
   
    //transform :[{ scale: 2.0} ,{translateX : 0} ,{ translateY : 24}]
  },
  content : {
    width: itemWidth ,
    height: itemHeight ,
    overflow: 'hidden'
  }
})
